module.exports = "<p>\n  sfa-list-icebox-inspect works!\n</p>\n"